var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SNS logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FEAA28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    d: "M16 6C21.5227 6 26 10.4773 26 16C26 21.5227 21.5227 26 16 26C10.4773 26 6 21.5227 6 16C6 10.4773 10.4773 6 16 6ZM16 7.81818C11.4813 7.81818 7.81818 11.4813 7.81818 16C7.81818 20.5187 11.4813 24.1818 16 24.1818C18.9231 24.1818 21.6241 22.6224 23.0857 20.0909C24.5472 17.5594 24.5472 14.4406 23.0857 11.9091C21.6241 9.37763 18.9231 7.81818 16 7.81818ZM19.6364 11.4545L17.6091 17.1418L12.3636 20.5455L14.3909 14.8582L19.6364 11.4545Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.2c928480d98fcdb4ead9de14c1a5d1d9.svg";
export { ForwardRef as ReactComponent };